import { Accordion, List, Paragraph } from '@zillow/constellation-10';

const LeaseQualificationAccordion = () => (
  <Accordion.Item value="lease-qualification" data-testid="LeaseQualificationAccordion">
    <Accordion.Header>How do I make sure my lease qualifies for Rental Protection?</Accordion.Header>
    <Accordion.Panel>
      <Paragraph css={{ marginBottom: '400' }}>
        {/* eslint-disable-next-line constellation/word-list */}
        Leases must have a 6-24 month term to be eligible for Rental Protection.
      </Paragraph>
      <Paragraph css={{ marginBottom: '400' }}>
        {/* eslint-disable-next-line constellation/word-list */}
        In addition, for a lease to qualify for Rental Protection, the lessees must have income of at least two times
        the monthly rent amount. You may sum the monthly incomes of all renters who sign the lease to meet this
        criteria.
      </Paragraph>

      <Paragraph css={{ marginBottom: '400' }}>
        To prove income, you must collect and save income documents to provide at claim time. How much financial history
        you gather is at your discretion. You may decide to collect any or all of these documents:
      </Paragraph>
      <List.Root css={{ marginBottom: '400' }}>
        <List.Item css={{ paddingBlock: '0' }}>2 most recent months of pay stubs</List.Item>
        <List.Item css={{ paddingBlock: '0' }}>3 most recent months of bank statements</List.Item>
        <List.Item css={{ paddingBlock: '0' }}>The most recent W-2 or tax return</List.Item>
      </List.Root>
    </Accordion.Panel>
  </Accordion.Item>
);

export default LeaseQualificationAccordion;
